import { useCarrier } from '../../contexts/CarrierContext';

export default function CarrierBadge({ carrier: supplied, variant = 'admin', className = '', srPrefix = 'اپراتور:' }) {
  const { carrier: active } = useCarrier();
  const carrier = supplied || active;
  if (!carrier) return null;
  return <span className={`carrier-badge carrier-badge-${variant} ${className}`}>
    <span className="carrier-sr-only">{srPrefix} </span>
    <span className="carrier-swatch" aria-hidden="true" style={{ backgroundColor: carrier.map_color }} />
    <bdi>{carrier.brand_name}</bdi>
  </span>;
}
